import { NgModule } from '@angular/core';

import { ORDER_CORE_FEATURE, OrderRootModule } from '@spartacus/order/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  imports: [
    OrderRootModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [ORDER_CORE_FEATURE]: {
          module: () => import('@seb/web-common/order/web-common-order.module').then((m) => m.WebCommonOrderModule),
          dependencies: [() => import('@spartacus/order/occ').then((m) => m.OrderOccModule)]
        }
      }
    })
  ]
})
export class OrderFeatureModule {}
